import UserStore from '@/store/user'

export default defineNuxtRouteMiddleware(async (to, from) => {
  const userStore = UserStore()

  if (to.path.includes('/app')) {
    return navigateTo(to.path.replace('/app', ''))
  }

  if (!userStore.fetched) {
    const lang = await getCookie('lang') as string
    if (lang) await useNuxtApp().$i18n.setLocale(lang)

    await userStore.initUser(true)
  }
})